import Vue from 'vue';
import Router from 'vue-router';

import DashboardLayout from '@/layout/DashboardLayout';
import AuthLayout from '@/layout/AuthLayout';

Vue.use(Router);

const beforeEnter = (to, from, next) => {
  next();
};

export default new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/admin/bxi-login'
    },
    {
      path: '/admin/bxi-login',
      component: AuthLayout,
      children: [
        {
          name: 'LoginViaBXI',
          path: '',
          component: () => import('@/views/BxiLogin.vue')
        }
      ]
    },
    {
      path: '/admin/login',
      redirect: '/admin/bxi-login',
      component: AuthLayout,
      children: [
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/Login.vue')
        }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/dashboard',
      component: DashboardLayout,
      beforeEnter,
      children: [
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/Dashboard.vue')
        },
        // {
        //   name: 'MemberProfile',
        //   path: 'member-profiles-v2',
        //   component: () =>
        //     import('@/views/benefitsv2/MemberManagement/MemberProfile.vue')
        // },
        {
          name: 'MemberProfile',
          path: 'member-profiles',
          component: () => import('@/views/MemberManagement/MemberProfile.vue')
        },
        {
          name: 'MemberTransaction',
          path: 'member-transactions',
          component: () =>
            import('@/views/MemberManagement/MemberTransaction.vue')
        },
        {
          name: 'SitePage',
          path: 'site-pages',
          component: () => import('@/views/SitePageManagement/SitePage.vue')
        },
        // !!! DEPRECATED
        // {
        //   name: 'SitePageV2',
        //   path: 'site-pages-v2',
        //   component: () => import('@/views/SitePageManagement/SitePageV2.vue')
        // },
        {
          name: 'Site',
          path: 'sites',
          component: () => import('@/views/SiteManagement/Site.vue')
        },
        {
          name: 'PointsAdjustment',
          path: 'points-adjustments',
          component: () =>
            import('@/views/PointsManagement/PointsAdjustment.vue')
        },
        // !!! DEPRECATED
        // {
        //   name: 'PointsAdjustmentV2',
        //   path: 'points-adjustments-v2',
        //   component: () =>
        //     import('@/views/PointsManagement/PointsAdjustmentV2.vue')
        // },
        {
          name: 'Item',
          path: 'items',
          component: () => import('@/views/ItemManagement/Item.vue')
        },
        {
          name: 'ItemInventory',
          path: 'item-inventory',
          component: () => import('@/views/ItemManagement/ItemInventory.vue')
        },
        {
          name: 'ItemRedemption',
          path: 'item-redemptions',
          component: () =>
            import('@/views/ItemManagement/ItemRedemptionForm.vue')
        },
        {
          name: 'CardInventory',
          path: 'card-inventory',
          component: () => import('@/views/CardManagement/Card.vue')
        },
        {
          name: 'CardType',
          path: 'card-types',
          component: () => import('@/views/CardManagement/CardType.vue')
        },
        {
          name: 'CardOrder',
          path: 'card-orders',
          component: () => import('@/views/CardManagement/CardOrder.vue')
        },
        {
          name: 'CardReceive',
          path: 'card-receiving',
          component: () => import('@/views/CardManagement/CardReceive.vue')
        },
        {
          name: 'CardTransferOut',
          path: 'transfer-out',
          component: () => import('@/views/CardManagement/TransferOut.vue')
        },
        {
          name: 'CardTransferIn',
          path: 'transfer-in',
          component: () => import('@/views/CardManagement/TransferIn.vue')
        },
        {
          name: 'CardSupplier',
          path: 'card-suppliers',
          component: () => import('@/views/CardManagement/CardSupplier.vue')
        },
        {
          name: 'CardSellingType',
          path: 'card-selling-types',
          component: () => import('@/views/CardSelling/CardSellingType.vue')
        },
        {
          name: 'PaymentType',
          path: 'payment-types',
          component: () => import('@/views/CardSelling/PaymentType.vue')
        },
        // !!! DEPRECATED
        // {
        //   name: 'MembershipProgram',
        //   path: 'membership-programs',
        //   component: () => import('@/views/ClientProfile/MembershipProgram.vue')
        // },
        {
          name: 'MembershipProgramV2',
          path: 'membership-programs-v2',
          component: () =>
            import('@/views/ClientProfile/MembershipProgramV2.vue')
        },
        {
          name: 'MembershipLevel',
          path: 'membership-levels',
          component: () => import('@/views/ClientProfile/MembershipLevel.vue')
        },
        {
          name: 'MemberStatus',
          path: 'member-statuses',
          component: () => import('@/views/ClientProfile/MemberStatus.vue')
        },
        {
          name: 'MemberTag',
          path: 'member-tags',
          component: () => import('@/views/ClientProfile/MemberTag.vue')
        },
        {
          name: 'CustomerType',
          path: 'customer-types',
          component: () => import('@/views/ClientProfile/CustomerType.vue')
        },
        {
          name: 'Messages',
          path: 'messages',
          component: () => import('@/views/ClientProfile/Message.vue')
        },
        {
          name: 'AdjustmentReasonType',
          path: 'adjustment-reason-types',
          component: () =>
            import('@/views/ClientProfile/AdjustmentReasonType.vue')
        },
        {
          name: 'DataPrivacyPolicy',
          path: 'data-privacy-policy',
          component: () => import('@/views/DPC/DataPrivacyPolicy.vue')
        },

        {
          name: 'InteractionType',
          path: 'interaction-types',
          component: () => import('@/views/ClientProfile/InteractionType.vue')
        },
        {
          name: 'Promotion',
          path: 'promotions',
          component: () => import('@/views/PromotionManagement/Promotion.vue')
        },
        {
          name: 'Voucher',
          path: 'vouchers',
          component: () => import('@/views/PromotionManagement/Voucher.vue')
        },
        {
          name: 'User',
          path: 'users',
          component: () => import('@/views/UserManagement/User.vue')
        },

        {
          name: 'UserGroup',
          path: 'user-groups',
          component: () => import('@/views/UserManagement/UserGroup.vue')
        },
        // !!! DEPRECATED
        // {
        //   name: 'CustomizedFieldsV2',
        //   path: 'custom-fields-v2',
        //   component: () =>
        //     import('@/views/AdvancedSettings/CustomizedFieldsV2.vue')
        // },
        {
          name: 'CustomizedFields',
          path: 'custom-fields',
          component: () =>
            import('@/views/AdvancedSettings/CustomizedFields.vue')
        },

        {
          name: 'CustomizedSettings',
          path: 'custom-settings',
          component: () =>
            import('@/views/AdvancedSettings/CustomizedSettings.vue')
        },
        {
          name: 'Settings',
          path: '/admin/settings',
          component: () => import('@/views/DefaultSettings/DefaultSettings.vue')
        }
      ]
    },
    {
      path: '/admin/games',
      redirect: '/admin/games/scratch-card',
      component: DashboardLayout,
      children: [
        {
          name: 'ScratchCard',
          path: 'scratch-card',
          component: () => import('@/views/Games/ScratchCard.vue')
        }
      ]
    },
    {
      path: '/admin/reports',
      redirect: '/admin/reports/cards',
      component: DashboardLayout,
      children: [
        {
          name: 'CardReportTemp',
          path: 'cards-temp',
          component: () => import('@/views/Reports/Cards/CardReportTemp.vue')
        },
        {
          name: 'CardReport',
          path: 'cards',
          component: () => import('@/views/Reports/Cards/CardReport.vue')
        },
        {
          name: 'TransactionReport',
          path: 'transactions',
          component: () =>
            import('@/views/Reports/Transactions/TransactionReport.vue')
        },
        {
          name: 'CustomerInfoReport',
          path: 'customers-info',
          component: () =>
            import('@/views/Reports/CustomerInfo/CustomerInfoReport.vue')
        },
        {
          name: 'CustomerInfoReportV2',
          path: 'customers-info-v2',
          component: () =>
            import('@/views/Reports/CustomerInfo/CustomerInfoReportV2.vue')
        },
        {
          name: 'CustomerInteractionReport',
          path: 'customer-interaction-logs',
          component: () =>
            import(
              '@/views/Reports/CustomerInteractions/CustomerInteractionReport.vue'
            )
        },
        {
          name: 'AuditLogsReport',
          path: 'audit-logs',
          component: () =>
            import('@/views/Reports/AuditLogs/AuditLogsReport.vue')
        },
        {
          name: 'ItemRewardsReport',
          path: 'item-rewards-inventory',
          component: () =>
            import('@/views/Reports/ItemRewardsReport/ItemRewardsReport.vue')
        },
        {
          name: 'CardSellingReport',
          path: 'card-selling',
          component: () =>
            import('@/views/Reports/CardSelling/CardSellingReport.vue')
        },
        {
          name: 'ScratchCardReport',
          path: 'scratch-card',
          component: () =>
            import('@/views/Reports/Gamification/ScratchCardReport.vue')
        }
      ]
    },
    {
      name: 'PageNotFound',
      path: '*',
      component: () => import('@/views/PageNotFound.vue')
    }
  ]
});
